let context: AudioContext | null = null;

export function playTone(kind: "pick" | "place" | "win" | "loss", enabled: boolean) {
  if (!enabled) return;
  context ??= new AudioContext();
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  const frequency = { pick: 420, place: 240, win: 740, loss: 120 }[kind];
  oscillator.type = kind === "loss" ? "sawtooth" : "triangle";
  oscillator.frequency.setValueAtTime(frequency, context.currentTime);
  if (kind === "win") oscillator.frequency.exponentialRampToValueAtTime(1120, context.currentTime + 0.16);
  gain.gain.setValueAtTime(0.08, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + 0.18);
  oscillator.connect(gain).connect(context.destination);
  oscillator.start();
  oscillator.stop(context.currentTime + 0.2);
}

export function playAssetSound(source: string, enabled: boolean, playbackRate = 1, volume = 0.5) {
  if (!enabled || !source) return;
  const audio = new Audio(source);
  audio.preload = "auto";
  audio.playbackRate = playbackRate;
  audio.volume = volume;
  void audio.play().catch(() => { /* Audio may be blocked until the first user interaction. */ });
}
